module.exports = __webpack_public_path__ + "img/add.72879a57.png";